import { from } from "rxjs";

export default class ChannelApi {
    static get(channel) {
        return from(

            fetch(
                `${process.env.REACT_APP_URL_CHANNELS_JSON}/${channel.toLowerCase()}.json`
            )
                .then(response => {
                    return response.json();
                })
                .then(responseJSON => {
                    return responseJSON;
                })
        );
    }
}
